var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#67ABAF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8769 13.7353C23.3595 13.4216 23.9868 13.4216 24.4694 13.7353L31.3463 17.2823V30.457H25.9413L22.5873 35.5V31.5669L24.7831 28.2612H29.1505V18.6094L23.6732 15.7863L18.1958 18.6094V28.2612H22.5632V30.457H16V17.2823L22.8769 13.7353Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9964 56.5142L31.5 44.4999H16.5L23.9964 56.5142Z",
    fill: "#67ABAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.d3a7854109447f4c3c2b79e4efcf926e.svg";
export { ForwardRef as ReactComponent };